import { z } from 'zod'
import { logRequestFailure } from '@/helpers/request-outcome'
import { api } from '@/helpers/apiClient'
import { reviewsToApproveDtoSchema, type ReviewsToApproveDto } from '@lib/dto/vendor-review.dto'
import type { DecideVendorReviewInput, SettleVendorReviewReportInput } from '@lib/input/vendor-review.input'
import type { IReviewApprovalService } from '@/types/ReviewApprovalService.types'

/** Reviews waiting for FLOH Venues' admins to approve them. */
class ReviewApprovalService implements IReviewApprovalService {
  async waiting(): Promise<ReviewsToApproveDto> {
    try {
      return await api.get('/admin/reviews', reviewsToApproveDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to list reviews to approve', {}, error)
      throw error
    }
  }

  async decide(reviewId: string, input: DecideVendorReviewInput): Promise<void> {
    try {
      await api.post(`/admin/reviews/${reviewId}/decision`, input, z.null())
    } catch (error) {
      logRequestFailure('Failed to decide a review', { reviewId, decision: input.decision }, error)
      throw error
    }
  }

  async decideReply(reviewId: string, input: DecideVendorReviewInput): Promise<void> {
    try {
      await api.post(`/admin/reviews/${reviewId}/reply-decision`, input, z.null())
    } catch (error) {
      logRequestFailure('Failed to decide a reply', { reviewId, decision: input.decision }, error)
      throw error
    }
  }

  async settleReport(reviewId: string, input: SettleVendorReviewReportInput): Promise<void> {
    try {
      await api.post(`/admin/reviews/${reviewId}/report-decision`, input, z.null())
    } catch (error) {
      logRequestFailure('Failed to settle a report', { reviewId, decision: input.decision }, error)
      throw error
    }
  }
}

export const reviewApprovalService = new ReviewApprovalService()
